import { Controller } from "stimulus";

// Usage:
//
// - Main link:
//  <a href="#" data-action="click->fader#toggle">...</a>
// - Content to fadeIn/fadeOut:
//  <div data-target="fader.content" data-action="click->fader#toggle">...</div>

// - "open" class will determine if the content should open. It will be added when the mouse enters,
//    but the open funciton has a timeout. If the mouse leaves, the class will be removed and the open
//    function won't do anything without it.
// - "keep" class will avoid the content to be close. It's used when moving the mouse from the link to the content.


export default class extends Controller {
  static targets = ["content", "arrow"];

  connect() {
    document.addEventListener("click", this.closeOnClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside.bind(this));
  }

  toggle(event) {
    event.preventDefault();
    if (this.contentTarget.classList.contains("open")) {
      this._hideContent();
    } else {
      this._showContent();
    }
  }

  show(event) {
    this.contentTarget.classList.add("open", "top-16", "fadeIn");
    this.contentTarget.classList.remove("hidden-top", "fadeOut");
    this._rotateArrow(true);
  }

  hide(event) {
    if (!this.contentTarget.contains(event.relatedTarget)) {
      this._hideContent();
    }
  }

  _showContent() {
    const isSubmenu = this.contentTarget.classList.contains("dropdown-submenu");
    this.contentTarget.classList.add("open", "fadeIn");
    if (!isSubmenu) this.contentTarget.classList.add("top-16");
    this.contentTarget.classList.remove("hidden-top", "fadeOut");
    if (isSubmenu) this._positionSubmenu();
    this._rotateArrow(true);
  }

  _positionSubmenu() {
    if (!this.contentTarget.classList.contains("dropdown-submenu")) return;

    const button = this.element.querySelector("button");
    if (!button) return;

    const rect = button.getBoundingClientRect();
    const dropdown = this.element.closest(".dropdown-click");
    const minTop = dropdown ? dropdown.getBoundingClientRect().top : rect.top;
    const viewportHeight = window.innerHeight;

    let top = rect.top;
    if (top < minTop) top = minTop;

    const maxHeight = viewportHeight - minTop;
    const submenuHeight = this.contentTarget.scrollHeight;

    if (top + Math.min(submenuHeight, maxHeight) > viewportHeight) {
      top = Math.max(minTop, viewportHeight - Math.min(submenuHeight, maxHeight));
    }

    this.contentTarget.style.top = `${top}px`;
    this.contentTarget.style.left = `${rect.right + 4}px`;
    this.contentTarget.style.maxHeight = `${viewportHeight - minTop}px`;
  }

  _hideContent() {
    this.contentTarget.classList.remove("open", "fadeIn", "top-16");
    this.contentTarget.classList.add("fadeOut");
    this._rotateArrow(false);
    setTimeout(() => {
      this.contentTarget.classList.add("hidden-top");
      if (this.contentTarget.classList.contains("dropdown-submenu")) {
        this.contentTarget.style.top = "";
        this.contentTarget.style.left = "";
      }
    }, 250);
  }

  _rotateArrow(isOpen) {
    if (this.hasArrowTarget) {
      if (isOpen) {
        this.arrowTarget.classList.add("rotate-90");
      } else {
        this.arrowTarget.classList.remove("rotate-90");
      }
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._hideContent();
    }
  }
}
